import ApiService from "@/services/api.service";

class NewsError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const buildNewsError = (error, fallbackMessage) => {
  const status = error && error.response ? error.response.status : null;
  const data = error && error.response ? error.response.data : null;
  const message =
    (data && (data.details || data.message || data.error)) ||
    error.message ||
    fallbackMessage;
  return new NewsError(status, message);
};

const NewsService = {
  list: async function() {
    try {
      const response = await ApiService.get("/news");
      return response;
    } catch (error) {
      throw buildNewsError(error, "Impossible de récupérer les actualités.");
    }
  },

  adminList: async function() {
    try {
      const response = await ApiService.get("/news/admin");
      return response;
    } catch (error) {
      throw buildNewsError(error, "Impossible de récupérer les actualités.");
    }
  },
  
  create: async function(payload) {
    try {
      const response = await ApiService.post("/news", payload);
      return response;
    } catch (error) {
      throw buildNewsError(error, "Impossible de créer l'actualité.");
    }
  },

  remove: async function(id) {
    try {
      const response = await ApiService.delete(`/news/${id}`);
      return response;
    } catch (error) {
      throw buildNewsError(error, "Impossible de supprimer l'actualité.");
    }
  },

  // optionId null = retirer son vote
  vote: async function(id, optionId) {
    try {
      const response = await ApiService.post(`/news/${id}/vote`, { optionId });
      return response;
    } catch (error) {
      throw buildNewsError(error, "Impossible d'enregistrer le vote.");
    }
  }
};

export default NewsService;

export { NewsService, NewsError };
